import React from "react";

// Fundraising images
import Fundraising1 from "../Assets/Volunteers/Fundraising/Fundraising1.jpg";
import Fundraising2 from "../Assets/Volunteers/Fundraising/Fundraising2.jpg";
import Fundraising3 from "../Assets/Volunteers/Fundraising/Fundraising3.jpg";
import Fundraising4 from "../Assets/Volunteers/Fundraising/Fundraising4.jpg";
import Fundraising5 from "../Assets/Volunteers/Fundraising/Fundraising5.jpg";
import Fundraising6 from "../Assets/Volunteers/Fundraising/Fundraising6.jpg";

// Team images
import Team1 from "../Assets/Volunteers/Team/Team1.jpg";
import Team2 from "../Assets/Volunteers/Team/Team2.jpg";
import Team3 from "../Assets/Volunteers/Team/Team3.jpg";
import Team4 from "../Assets/Volunteers/Team/Team4.jpg";
import Team5 from "../Assets/Volunteers/Team/Team5.jpg";
import Team6 from "../Assets/Volunteers/Team/Team6.jpg";
import Team7 from "../Assets/Volunteers/Team/Team7.jpg";
import Team8 from "../Assets/Volunteers/Team/Team8.jpg";

// Regatta images
import Regatta1 from "../Assets/Volunteers/Regatta/Regatta1.jpg";
import Regatta2 from "../Assets/Volunteers/Regatta/Regatta2.jpg";
import Regatta3 from "../Assets/Volunteers/Regatta/Regatta3.jpg";
import Regatta4 from "../Assets/Volunteers/Regatta/Regatta4.jpg";
import Regatta5 from "../Assets/Volunteers/Regatta/Regatta5.jpg";
import Regatta6 from "../Assets/Volunteers/Regatta/Regatta6.jpg";

const fundraisingImages = [
  Fundraising1,
  Fundraising2,
  Fundraising3,
  Fundraising4,
  Fundraising5,
  Fundraising6,
];

const teamImages = [Team1, Team2, Team3, Team4, Team5, Team6, Team7, Team8];

const regattaImages = [
  Regatta1,
  Regatta2,
  Regatta3,
  Regatta4,
  Regatta5,
  Regatta6,
];

const sectionStyle = {
  marginTop: "2rem",
  textAlign: "left",
};

const listStyle = {
  margin: "0.75rem 0 0 1.25rem",
  lineHeight: "1.8",
};

const collageStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
  gap: "0.75rem",
  marginTop: "1rem",
};

const imageStyle = {
  width: "100%",
  height: "140px",
  objectFit: "cover",
  borderRadius: "0.75rem",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
};

function Volunteers() {
  return (
    <div
      className="centered-page"
      style={{ padding: "1rem", maxWidth: "900px" }}
    >
      <h2 style={{ textAlign: "left" }}>Volunteer Opportunities</h2>
      <p>
        Our crew wouldn't be possible without the help of volunteers throughout
        the year. Whether it's helping with regatta logistics, fundraising,
        donating, or helping out at the crew tent, it's supporters like you that
        make all this happen
      </p>
<section style={sectionStyle}>
        <h3>Fundraising Tasks</h3>
        <ul style={listStyle}>
          <li>
            Help with the annual Luau, Cornbeef Dinner, and other events. 
          </li>
          <li>
            Collect for the rummage sale, organize donations, and working the sale day
          </li>
          <li>
            Organize individual fundraising efforts, like our Ham sales, Erg-a-thon, and gift card sales.
          </li>
        </ul>
       <div style={collageStyle}>
          {fundraisingImages.map((src, index) => (
            <img
              key={`fundraising-${index}`}
              src={src}
              alt={`Fundraising volunteer ${index + 1}`}
              style={imageStyle}
            />
          ))}
        </div>
      </section>
      <section style={sectionStyle}>
        <h3>Team Tasks</h3>
        <ul style={listStyle}>
          <li>
            Crew tent logistics, hauling, setting up, and packing the gear. 
          </li>
          <li>
            Meap prep, tent cleanup, and helping with meals on regatta days.
          </li>
          <li>
            Donate food, drinks, and snacks for the regattas. 
          </li>
        </ul>
        <div style={collageStyle}>
          {teamImages.map((src, index) => (
            <img
              key={`team-${index}`}
              src={src}
              alt={`Team volunteer ${index + 1}`}
              style={imageStyle}
            />
          ))}
        </div>
      </section>

      <section style={sectionStyle}>
        <h3>Regatta Tasks</h3>
        <ul style={listStyle}>
          <li>
            Helping with regatta logistics, like parking, registration, and hospitality.
          </li>
          <li>
            Support on-water safety, course marshaling, and timing assistance.
          </li>
          <li>
            Concessions and souvenir sales.
          </li>
        </ul>
        <div style={collageStyle}>
          {regattaImages.map((src, index) => (
            <img
              key={`regatta-${index}`}
              src={src}
              alt={`Regatta volunteer ${index + 1}`}
              style={imageStyle}
            />
          ))}
        </div>
      </section>

      
    </div>
  );
}

export default Volunteers;
